module.exports = __webpack_public_path__ + "static/media/LB.fad6de03.svg";